import { AfterViewInit, Directive, OnDestroy, inject } from '@angular/core';
import { Select } from 'primeng/select';
import { ReplaySubject, takeUntil } from 'rxjs';

/**
 * This directive is used to handle the focus of the p-select component when used in a wrapper component.
 */
@Directive({
  selector: '[appDropdownFocusHandler]p-select',
  standalone: true,
})
export class DropdownFocusHandlerDirective implements AfterViewInit, OnDestroy {
  private readonly dropdown = inject(Select);
  private readonly destroy$ = new ReplaySubject<void>(1);

  ngAfterViewInit(): void {
    this.dropdown.onHide.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.dropdown.el.nativeElement.focus();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
